class HSM {
  async _init() {
    return true
  }
  async show() {
    let options = [
      { key: "changeRoomStatus", value: "Update Room Status" },
      { key: "changeRoomNumber", value: "Change Room Number" },
      { key: "clearUserData", value: "Clear User Data" }
    ]

    let result = await _$.vue.$sidepane("Hotel Service Menu", _$.vue.$t("Please choose one of the following action."), options, "right")
    if (!result) return false
    else this[result]()

    return true
  }
  async changeRoomStatus() {
    const options = [
      { key: "1", value: "Dirty/Vacant" },
      { key: "2", value: "Dirty/Occupied" },
      { key: "3", value: "Clean/Vacant" },
      { key: "4", value: "Clean/Occupied" },
      { key: "5", value: "Inspected/Vacant" },
      { key: "6", value: "Inspected/Occupied" }
    ]

    const result = await _$.vue.$sidepane(
      "Room Maid Status",
      _$.vue.$t("Please specify one of the following statuses to update the room's status."),
      options,
      "right"
    )

    const { location } = __.device.get()
    if (result) __.api.fidelio.updateRoomStatus({ room: location, status: result })

    return this.show()
  }
  async changeRoomNumber() {
    await __.device.assign()
    return this.show()
  }
  async clearUserData() {
    return __.device.clearData()
  }
}

export default new HSM()
